import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false
  },
  mutations: {
    changeLoadingStatus(state){
      state.isLoading = !state.isLoading
    }
  },
  actions: {
    doChangeLoadingStatus(context){
      context.commit('changeLoadingStatus')
    }
  },
  modules: {
  }
})
